import Returns from '../../../../components/returns/returns.desktop';
import returns from './returns';

const configuredReturns = returns(Returns);
export default configuredReturns;
